import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useLoading } from "./context/LoadingContext";
import AppLoader from "./components/AppLoader";
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import BottomMenu from './components/BottomMenu';
import Sidebar from './components/Sidebar';
import LoginPage from './components/Login';
import { useAuth } from './AuthContext';
import AppRoutes from './AppRoutes';
import './assets/styles/global.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import apiLinks from '../src/config/apiLinks.json';
import apiService from '../src/utils/apiService';
import Loading from './components/General/Loading';
import Breadcrumb from './components/General/Breadcrumb';
import MRTViewer from './components/MRTViewer';
import Home from './components/Home';
import ChangePassword from './components/Account/ChangePassword'
import Invoices from './components/Invoices/Invoices';
const componentMap = {
  invoices: Invoices,
};
const normalizeController = (controller) =>
  controller?.toLowerCase().trim();


const App = () => {
  const { isLoading } = useLoading();
  const location = useLocation();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [isMenuLoaded, setIsMenuLoaded] = useState(false);
  const [menuData, setMenuData] = useState([]);
  const { accessToken, autoLogin, validateToken, isTokenValid } = useAuth();

  useEffect(() => {

    const fetchMenuData = async () => {
      try {
        setIsMenuLoaded(false);

        const data = await apiService.get(
          `${apiLinks.baseUrl}${apiLinks.Settings.GetMenus}`,
          {},
          autoLogin
        );        
        if (data.Menus && data.Menus.length > 0) {
          setMenuData(data.Menus);
        }

      } catch (error) {
        // console.error("Error fetching menu data:", error);
      } finally {
        setIsMenuLoaded(true);
      }
    };

    fetchMenuData();
  }, [accessToken]);
  useEffect(() => {

    const checkToken = async () => {
      if (accessToken) {
        const valid = await validateToken();
        if (!valid) {
          autoLogin();
        }
      }
    };
    checkToken();
  }, [accessToken, validateToken, autoLogin]);

  const toggleSidebar = () => {
    setOpenSidebar((prev) => !prev);
  };
  if (!isTokenValid && accessToken) {
    return <AppLoader show />;
  }

  const hideBottomMenu = location.pathname === "/login";
  return (
    <>
      <AppLoader show={isLoading} />
      {accessToken && <Navbar toggleSidebar={toggleSidebar} openSidebar={openSidebar} />}
      <Box>
        {accessToken && (
          <Sidebar open={openSidebar} toggleSidebar={toggleSidebar} />
        )}
        <Box
          component="main"
          className={accessToken ? 'container-fluid' : ''}
          sx={{
            width: '100%',
            marginTop: accessToken ? '60px' : '0',
          }}
        >
          {isMenuLoaded && <Breadcrumb menuData={menuData} />}
          <Routes>
            {/* Redirect to login if not authenticated */}
            <Route
              path="/login"
              element={accessToken ? <Navigate to="/" /> : <LoginPage />}
            />
            <Route
              index={true}
              element={<Home />}
            />

            <Route path="/Account/ChangePassword" element={<ChangePassword />} />
            {/* Dynamically add routes for filtered components */}
            {menuData.map((menu) => {
              const controllerName = normalizeController(menu.Menu_Controller);
              const Component = componentMap[controllerName];

              if (!Component) return null; 

              return (
                <Route
                  key={menu.Menu_Id}
                  path={`/${controllerName}`}
                  element={<Component />}
                />
              );
            })}
          </Routes>
        </Box>
      </Box>
      {!hideBottomMenu && <BottomMenu />}

    </>
  );
};

export default App;